import React from 'react';
import PromocardCarousel from './promocardCarousel';
import ItemCarousel from './carousel/itemCarousel';

const Carousel = ({ post, postId }) => {
  const componentMap = {
    I: <PromocardCarousel className="promoCard" post={post} />,
    W: <ItemCarousel postId={postId} post={post} cards={post.cards} />,
  };
  return <React.Fragment>{componentMap[post.subType]}</React.Fragment>;
};

export default Carousel;
